(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("dwFw2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d6d61fb56928c1d3$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $dfLVZ = parcelRequire("dfLVZ");

var $kqTTL = parcelRequire("kqTTL");

var $2eeTP = parcelRequire("2eeTP");

var $hPa9t = parcelRequire("hPa9t");
const $d6d61fb56928c1d3$var$QuickInfoProject = ()=>{
    const { estate: data } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const [propertyType, setPropertyType] = (0, $dTCkE.useState)("");
    const [livingArea, setLivingArea] = (0, $dTCkE.useState)("");
    const [numberOfRooms, setNumberOfRooms] = (0, $dTCkE.useState)("");
    const [isLoaded, setIsLoaded] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        setIsLoaded(false);
        if (data?.propertyType) setPropertyType(data?.propertyType);
        if (data?.roomRange?.minValue && data?.roomRange?.maxValue && data?.roomRange?.minValue !== data?.roomRange?.maxValue) setNumberOfRooms(data?.roomRange?.minValue + "-" + data?.roomRange?.maxValue + " rum");
        else if (data?.roomRange?.minValue) setNumberOfRooms(data?.roomRange?.minValue + " rum");
        else if (data?.roomRange?.maxValue) setNumberOfRooms(data?.roomRange?.maxValue + " rum");
        if (data?.livingSpaceRange?.maxValue || data?.livingSpaceRange?.minValue) {
            if (data?.livingSpaceRange?.maxValue && data?.livingSpaceRange?.minValue && data?.livingSpaceRange?.maxValue !== data?.livingSpaceRange?.minValue) setLivingArea(data?.livingSpaceRange?.minValue.toString().replace(".", ",") + " - " + data?.livingSpaceRange?.maxValue.toString().replace(".", ",") + " m\xb2");
            else if (data?.livingSpaceRange?.maxValue) setLivingArea(data?.livingSpaceRange?.maxValue.toString().replace(".", ",") + " m\xb2");
            else if (data?.livingSpaceRange?.minValue) setLivingArea(data?.livingSpaceRange?.minValue.toString().replace(".", ",") + " m\xb2");
            else if (data?.buildingInfo?.livingSpace) setLivingArea(data?.buildingInfo?.livingSpace.toString().replace(".", ",") + " m\xb2");
        }
        setIsLoaded(true);
    }, [
        data?.propertyType,
        data?.buildingInfo?.livingSpace,
        data?.associationInfo?.numberOfLocals,
        data?.livingSpaceRange?.minValue,
        data?.livingSpaceRange?.maxValue
    ]);
    if (!isLoaded) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $2eeTP.default), {});
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-wrap lg:flex-row lg:flex-auto mt-4 lg:mt-6 px-3 lg:px-7 xxl:px-4 quickInfo font-ic max-w-7xl mx-auto",
        children: [
            livingArea && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).LivingSpace,
                value: livingArea,
                iconUrl: "/Images/Icons/objectPage/livingArea.svg"
            }),
            numberOfRooms && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).Room,
                value: numberOfRooms,
                iconUrl: "/Images/Icons/objectPage/room.svg"
            }),
            data?.numberOfObjects && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).NumberOfEstates,
                value: data?.numberOfObjects.toString() + " st",
                iconUrl: "/Images/Icons/objecttypes/liten_nyproduktion-black.svg"
            }),
            data?.addressInfo?.streetAddress && data?.addressInfo?.streetAddress != "-" && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.Location).Address,
                value: data?.addressInfo?.streetAddress,
                iconUrl: "/Images/Icons/objectPage/location.svg"
            }),
            data?.buildingInfo?.buildingYear && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).BuildingYear,
                value: data?.buildingInfo?.buildingYear,
                comment: data?.buildingInfo?.commentaryForBuildingYear,
                iconUrl: "/Images/Icons/objectPage/buildingYear.svg"
            }),
            data?.buildingInfo?.propertyUnitDesignation && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).PropertyUnitDesignation,
                value: data?.buildingInfo?.propertyUnitDesignation,
                iconUrl: "/Images/Icons/objectPage/fastighetsbeteckning.svg"
            }),
            data?.addressInfo?.municipality && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.Location).Municipality,
                value: data?.addressInfo?.municipality,
                iconUrl: "/Images/Icons/objectPage/municipality.svg"
            }),
            data?.estateTypeAsString && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).Type,
                value: data?.estateTypeAsString,
                iconUrl: "/Images/Icons/objectPage/type.svg"
            }),
            propertyType && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).ObjectType,
                value: propertyType,
                iconUrl: "/Images/Icons/objectPage/inriktning.svg"
            }),
            data?.dates?.possibleAccessDate && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.General).AccessDate,
                value: data?.dates?.possibleAccessDate,
                iconUrl: "/Images/Icons/objectPage/access.svg"
            }),
            data?.movingIn && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.General).AccessDate,
                value: data?.movingIn,
                iconUrl: "/Images/Icons/objectPage/access.svg"
            })
        ]
    });
};
var $d6d61fb56928c1d3$export$2e2bcd8739ae039 = $d6d61fb56928c1d3$var$QuickInfoProject;

});

})();
//# sourceMappingURL=QuickInfoProject.d792e90e.js.map
